import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
// Import Component Styles
import { HeaderWrapper, LanguageWrapper } from './styles';
import { HRBLOGO } from '../../../../components/Icons';

const DisbursementsHeader = withTheme(({ setLocale, locale }) => {
  // fetch locale from local storage
  React.useEffect(() => {
    const locale = sessionStorage.getItem('locale');
    if (locale === 'fr') {
      setLocale(locale);
    }
  }, []);
  const updateLocale = lc => {
    sessionStorage.removeItem('x-guard-flow');
    sessionStorage.setItem('locale', lc);
    setLocale(lc);
  };
  return (
    <HeaderWrapper>
      <div className="header-content">
        <HRBLOGO />
        <LanguageWrapper>
          <div className="language-selector">
            <div
              className={locale === 'en' ? 'active' : ''}
              onClick={() => updateLocale('en')}
              tabIndex={0}
              role="button"
              onKeyDown={e => e.key === 'Enter' && updateLocale('en')}
            >
              EN
            </div>
            <div
              className={locale === 'fr' ? 'active' : ''}
              onClick={() => updateLocale('fr')}
              tabIndex={0}
              role="button"
              onKeyDown={e => e.key === 'Enter' && updateLocale('fr')}
            >
              FR
            </div>
          </div>
        </LanguageWrapper>
      </div>
    </HeaderWrapper>
  );
});

DisbursementsHeader.propTypes = {
  setLocale: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
};

export default DisbursementsHeader;
